<div class="policyWidget beneWidget beneListWidget coverPathWidget">
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image--blue wrapClose__logo" alt="Coverpath"></div>
        <button type="button" class="close" (click)="checkCancel();">Close</button>
      </div>
    </div>
  </div>

  <div class="wrap wrapHead">
    <form [formGroup]="beneForm" novalidate id="beneForm">
      <div class="pageHead coverPathForm">
        <legend class="title">{{addOrEdit}} {{beneTypeName}} beneficiary</legend>
        <div class="{{headerClass}}">{{headerText}}</div>

        <div class="formSubhead" id="beneficiary-type">
          <div class="formElem">
            <label for="type">Beneficiary type</label>
            <div class="contentPadding">
              <select-basic
                [propertyName]="'selectedType'"
                [placeholder]="'Type'"
                [optionValues]="beneTypes"
                (valueChanged)="switchComponent()"
                [noLabel]="true"
                [formGroupComponent]="true"
                [isDisabled]="isDisabled"
                formControlName="selectedType"
              ></select-basic>
            </div>
          </div>
        </div>
        <div>
          <br />
        </div>
        <hr />
      </div>
    </form>
  </div>

  <div #target></div>

  <div class="wrap wrapFoot" *ngIf="!componentSelected">
    <div class="cta">
      <button type="submit" class="btnSubmit" disabled>Submit</button>
      <button type="button" class="btnCancel" (click)="cancel();">Cancel</button>
    </div>
  </div>
</div>

<modal *ngIf="modalService.showModal" [dismiss]="dismiss"></modal>
